<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.gerenciamentoMedico"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="edit(item.id)"
                authorize="edit-ambulatorio-gerenciamento-medico"
                color="primary"
                small
                title="Gerenciar"
            >
                <rkm-icon icon="cog" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            gerenciamentoMedico: this.getConectaSusRepository('ambulatorio.gerenciamentoMedico'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'cadastroCidadao.nome', searchable: true, sortable: true},
            {key: 'dataNascimento', label: 'Data de nascimento', name: 'cadastroCidadao.dataNascimento', searchable: true, sortable: true},
            {key: 'cpf', label: 'CPF', name: 'cadastroCidadao.cpf', searchable: true, sortable: true},
            {key: 'cns', label: 'CNS', name: 'cadastroCidadao.cns', searchable: true, sortable: true},
            {key: 'actions', label: 'Ações', name: 'actions', class: 'col-min'},
        ],
    }),
    methods: {
        edit(id) {
            this.$router.push({ name: 'ambulatorio-gerenciamento-medico-edit', params: { id } })
        },
    },
    mixins: [repository],
}
</script>